export default "__VITE_ASSET__BYcWFUcL__"